<template>
    <div>
        <div class="page-title">提出修改記錄 Request</div>
        <el-card class="box-card">
              <requestFrom ref="dynamicValidateForm" :formLabelAlign="applicationDetail"></requestFrom>
              <el-button type="info" @click="onSubmit">提交 Submit</el-button>
        </el-card>

        <div class="copyright-card">
            <copyrightCard></copyrightCard>
        </div>
    </div>
</template>

<script>
    import {getApplicationDetail,addRequestFromApplications} from '@/api/parent/application'
    import copyrightCard from '@/components/copyrightCard'
    import requestFrom from './components/requestFrom'
    export default {
        components: { copyrightCard,requestFrom },
        props:{
            id: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                applicationDetail: {
                    detail:null
                }
            }
        },
        created(){
            this.getApplicationDetail()
        },
        methods:{
            onSubmit(){
                this.$refs.dynamicValidateForm.$refs.dynamicValidateForm.validate((valid) => {
                    if (valid) {
                    this.addRequestFromApplications()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                    });
            
            },
            addRequestFromApplications(){
                let from = {
                    applicationFormId:this.id,
                    detail:this.applicationDetail.detail
                }
                addRequestFromApplications(from).then(()=>{
                     this.$message.success('Processed successfully')
                      this.$router.push({ path:`/parent/request` });
                }) 
            },
            getApplicationDetail(){
                getApplicationDetail(this.id).then((v)=>{
                     this.applicationDetail = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.home-title{
    color: #337AB7;
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 30px;
}
.box-card{
    margin-bottom: 30px;
    text-align: right;
}
.copyright-card{
    background-color: #fff;
}
.el-button--info {
    width: auto;
    text-align: right;
}
</style>